var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMessageSync24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.13,7a8.038,8.038,0,0,0-2.37,2H6V7ZM6,16,4,18V4H20V6.262a7.921,7.921,0,0,1,2,.817V4a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,4V22l4-4h5.079a7.921,7.921,0,0,1-.817-2Zm12,1a3,3,0,0,1-3-3,2.965,2.965,0,0,1,.446-1.554l-1.434-1.434A4.979,4.979,0,0,0,18,19v2l3-3-3-3Zm0-8V7l-3,3,3,3V11a3,3,0,0,1,3,3,2.965,2.965,0,0,1-.446,1.554l1.434,1.434A4.979,4.979,0,0,0,18,9Zm-7.413,2H6v2h4.069A7.909,7.909,0,0,1,10.587,11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default __webpack_public_path__ + "media/ic_message_sync_24dp.svg";
export { SvgIcMessageSync24Dp as ReactComponent };